import { createReducer, on } from '@ngrx/store';
import {
  loadBuildInfo,
  loadBuildInfoError,
  loadBuildInfoSuccess,
} from '@app/core/store/app-context/app-context.actions';
import { initialAppContextState, IAppContextState } from '@app/core/store/app-context/app-context.state';

export const appContextReducer = createReducer(
  initialAppContextState,

  on(loadBuildInfo, (state: IAppContextState) => ({
    ...state,
    buildInfo: {
      ...state.buildInfo,
      loading: true,
    },
  })),

  on(loadBuildInfoSuccess, (state: IAppContextState, { data }) => ({
    ...state,
    buildInfo: {
      ...state.buildInfo,
      data,
      loading: false,
      loaded: true,
    },
  })),

  on(loadBuildInfoError, (state: IAppContextState) => ({
    ...state,
    buildInfo: {
      ...state.buildInfo,
      data: null,
      loading: false,
      loaded: true,
    },
  }))
);
